import { useGetFormalOffer } from '@api/lendingAPI/lapiHooks';
import { Accordion } from '@iwoca/orion';
import { getCurrentLocation } from '@iwRouter/HistoryProvider';
import { getQueryParameter } from '@iwRouter/LocationHelper';
import { FormattedMessage } from 'react-intl';

import {
    FullTermDurationRow,
    InterestRateRow,
    WithdrawalAmountRow,
    WithdrawalFeesRow
} from '../../ApprovedView/LoanSummary/SummaryRow/SummaryRow';

export const MobileFundingRequirementsLoanSummary = () => {
    const location = getCurrentLocation();
    const offerId = getQueryParameter(location, 'offerId');
    const amount = getQueryParameter(location, 'amount');
    const drawdownAmount = amount ? Number(amount) : undefined;
    const { formalOffer } = useGetFormalOffer(offerId);
    const selectedOffer = formalOffer ?? undefined;

    return (
        <Accordion.Item
            variant="secondary"
            size="large"
            className="rounded-s bg-secondary-95"
        >
            <Accordion.Header>
                <Accordion.Title className="text-m font-bold text-primary-10">
                    <FormattedMessage
                        id="_.funding_requirements.loan_summary.title"
                        defaultMessage="Your loan summary"
                    />
                </Accordion.Title>
                <Accordion.Trigger />
            </Accordion.Header>
            <Accordion.Content>
                <div className="flex flex-col gap-m">
                    <WithdrawalAmountRow drawdownAmount={drawdownAmount} />
                    <InterestRateRow
                        selectedOffer={selectedOffer}
                        drawdownAmount={drawdownAmount}
                    />
                    <WithdrawalFeesRow selectedOffer={selectedOffer} />
                    <FullTermDurationRow
                        selectedOffer={selectedOffer}
                        drawdownAmount={drawdownAmount}
                    />
                </div>
            </Accordion.Content>
        </Accordion.Item>
    );
};
